var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKhanbanIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8409 1.71289H7.84983C5.85142 1.71289 4.85221 1.71289 4.08892 2.11736C3.41751 2.47315 2.87164 3.04086 2.52954 3.73912C2.14062 4.53294 2.14062 5.57212 2.14062 7.65046V18.0412C2.14062 20.1196 2.14062 21.1587 2.52954 21.9525C2.87164 22.6508 3.41751 23.2185 4.08892 23.5743C4.85221 23.9788 5.85142 23.9788 7.84983 23.9788H17.8409C19.8393 23.9788 20.8385 23.9788 21.6018 23.5743C22.2732 23.2185 22.8191 22.6508 23.1612 21.9525C23.5501 21.1587 23.5501 20.1196 23.5501 18.0412V7.65046C23.5501 5.57212 23.5501 4.53294 23.1612 3.73912C22.8191 3.04086 22.2732 2.47315 21.6018 2.11736C20.8385 1.71289 19.8393 1.71289 17.8409 1.71289Z",
    stroke: "white",
    strokeWidth: 1.71276,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9164 5.99512H7.83865C8.34877 5.99512 8.76091 6.45304 8.76091 7.01985V14.1929C8.76091 14.7597 8.34877 15.2177 7.83865 15.2177H6.9164C6.40627 15.2177 5.99414 14.7597 5.99414 14.1929V7.01985C5.99414 6.45304 6.40627 5.99512 6.9164 5.99512Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2523 5.99512H13.1746C13.6847 5.99512 14.0968 6.48968 14.0968 7.10182V10.4219C14.0968 11.0341 13.6847 11.5287 13.1746 11.5287H12.2523C11.7422 11.5287 11.3301 11.0341 11.3301 10.4219V7.10182C11.3301 6.48968 11.7422 5.99512 12.2523 5.99512Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5883 5.99512H18.5105C19.0206 5.99512 19.4328 6.44159 19.4328 6.99423V16.9853C19.4328 17.538 19.0206 17.9844 18.5105 17.9844H17.5883C17.0781 17.9844 16.666 17.538 16.666 16.9853V6.99423C16.666 6.44159 17.0781 5.99512 17.5883 5.99512Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKhanbanIcon);
export default __webpack_public_path__ + "static/media/khanban-icon.bc3d817c5676f68892916adfa6aa34db.svg";
export { ForwardRef as ReactComponent };